import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Main language resource files
import zhTranslation from './locales/zh.json';
import enTranslation from './locales/en.json';

// Namespaced translation files
import enContactTranslation from './locales/en/contact.json';
import cnContactTranslation from './locales/cn/contact.json';

const resources = {
  zh: {
    translation: zhTranslation,
    contact: cnContactTranslation
  },
  en: {
    translation: enTranslation,
    contact: enContactTranslation
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en', // Read from localStorage or default to English
    fallbackLng: 'en', // Fallback to English if selected language not available
    interpolation: {
      escapeValue: false // Don't escape HTML
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'language',
      caches: ['localStorage']
    },
    ns: ['translation', 'contact'], // Available namespaces
    defaultNS: 'translation', // Default namespace when none is specified
  });

export default i18n; 